var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackarrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #202020;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.81,19.43h0l-.12.15,0,.08a.5.5,0,0,0-.08.2l0,.08h0a1.27,1.27,0,0,0,0,.39l0,.08,0,.11a.31.31,0,0,1,.05.1l0,.07a.79.79,0,0,0,.12.15l9,9a1,1,0,0,0,1.59-1.23.77.77,0,0,0-.18-.18L9,21.15H36a1,1,0,0,0,0-2H9l7.28-7.3a1,1,0,0,0-.17-1.41,1,1,0,0,0-1.24,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackarrow);
export default __webpack_public_path__ + "static/media/backarrow.90d262935cbcf64cccb66a18cea46f00.svg";
export { ForwardRef as ReactComponent };